import { forwardRef } from "react";
import {
  Description,
  Field,
  Input as HeadlessInput,
  Label,
} from "@headlessui/react";
import PropTypes from "prop-types";
import cn from "classnames";
// Styles
import styles from "./Input.module.scss";

const Input = forwardRef(
  (
    { label, error, placeholder, required = false, className, ...restProps },
    ref
  ) => {
    return (
      <div className={cn(styles.root, className)}>
        <Field>
          <Label className={styles.label}>
            {label} {required && <span>*</span>}
          </Label>

          <HeadlessInput
            placeholder={placeholder}
            className={cn(styles.input, {
              [styles.error]: Boolean(error),
            })}
            ref={ref}
            {...restProps}
          />

          {error && (
            <Description className={styles.errorDescription}>
              {error}
            </Description>
          )}
        </Field>
      </div>
    );
  }
);

Input.propTypes = {
  ref: PropTypes.object,
  label: PropTypes.string,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string,
};

export default Input;
